<template>
  <div class="HonoraryCertificate">
    <div class="HonoraryCertificate_content">
      <div class="HonoraryCertificate_right">
        <!-- 资质title -->
        <div class="HonoraryCertificate_title">
          <el-divider>
            <div class="HonoraryCertificate_name">荣誉资质</div>
            <div class="HonoraryCertificate_text">Honorable Mention</div>
          </el-divider>
        </div>
        <!-- 资质end -->
        <el-pagination
          class="mention_pagination"
          v-show="ryListLog"
          small
          background
          layout="prev, pager, next"
          :page-size="8"
          :total="ryListLog"
          @current-change="changeRyPage"
        >
        </el-pagination>
        <!-- 资质列表 -->
        <div class="HonoraryCertificate_image">
          <div
            class="HonoraryCertificate_image_item"
            v-for="(item, index) in ryTypeList"
            :key="index"
          >
            <div class="HonoraryCertificate_image_item1">
              <img :src="item.imageUrl" oncontextmenu="return false;" />
            </div>
            <div class="HonoraryCertificate_image_item1_name">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <!-- 著作title -->
        <div class="HonoraryCertificate_title">
          <el-divider>
            <div class="HonoraryCertificate_name">专利著作</div>
            <div class="HonoraryCertificate_text">cooperative partner</div>
          </el-divider>
        </div>
        <el-pagination
          class="mention_pagination"
          v-show="zlListLog"
          small
          background
          layout="prev, pager, next"
          :page-size="8"
          :total="zlListLog"
          @current-change="changeZlPage"
        >
        </el-pagination>
        <!-- 著作列表 -->
        <div class="HonoraryCertificate_image">
          <div
            class="HonoraryCertificate_image_item"
            v-for="(item, index) in zlTypeList"
            :key="index"
          >
            <div class="HonoraryCertificate_image_item2">
              <img :src="item.imageUrl" />
            </div>
            <div class="HonoraryCertificate_image_item1_name">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
        <!-- 著作列表end -->
      </div>
    </div>
  </div>
</template>
<script>
import { getHonorInfo, getPatentInfo } from "@/api/index";
export default {
  data() {
    return {
      ryTypeList: [],
      zlTypeList: [],
      ryListLog: 0,
      zlListLog: 0,
      ryPageNumber: 1,
      zlPageNumber: 1,
      ryPageSize: 8,
      zlPageSize: 8,
    };
  },
  mounted() {
    this.getHonorList();
    this.getPatentList();
  },
  methods: {
    //获取荣誉资质
    getHonorList() {
      getHonorInfo(this.ryPageNumber, this.ryPageSize).then((res) => {
        // console.log("荣誉", res);
        this.ryTypeList = res.data.ryTypeList.list;
        this.ryListLog = res.data.ryTypeList.totalCount;
      });
    },
    getPatentList() {
      getPatentInfo(this.zlPageNumber, this.zlPageSize).then((res) => {
        // console.log("著作", res);
        this.zlTypeList = res.data.zlTypeList.list;
        this.zlListLog = res.data.zlTypeList.totalCount;
      });
    },
    changeRyPage(page) {
      // console.log("荣誉页数", page);
      this.ryPageNumber = page;
      this.getHonorList();
    },
    changeZlPage(page) {
      // console.log("资质页数", page);
      this.zlPageNumber = page;
      this.getPatentList();
    },
  },
};
</script>
<style scoped>
/* 分页 */
.mention_pagination {
  text-align: right;
}

.HonoraryCertificate {
  width: 1200px;
  margin: 0 auto;
}
.HonoraryCertificate_content {
  display: flex;
  padding-bottom: 50px;
}
.HonoraryCertificate_left {
  padding-top: 120px;
}
.HonoraryCertificate_right {
  text-align: center;
  width: 100%;
}
.HonoraryCertificate_name {
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin: 0 70px;
}
.HonoraryCertificate_text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.HonoraryCertificate_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 35px;
  /*width: 1025px;*/
  width: 100%;
}
.HonoraryCertificate_title_name {
  font-size: 28px;
  text-align: center;
  font-weight: 600;
}
.HonoraryCertificate_image {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  width: 100%;
  margin-bottom: 159px;
}
.HonoraryCertificate_image_item {
  /* height: 445px; */
  width: 25%;
}
.HonoraryCertificate_image_item1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 35px 0px;
  /*margin-right: 31px;*/
  border: 1px solid #e5e5e5;
  width: 277px;
  height: 207px;
}

.HonoraryCertificate_image_item2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 35px 15px;
  border: 1px solid #e5e5e5;
  width: 282px;
  height: 352px;
}
.HonoraryCertificate_image_item2 img {
  width: 250px;
  height: 340px;
}
.HonoraryCertificate_image_item1 img {
  width: 235px;
  height: 154px;
}
.HonoraryCertificate_image_item1_name {
  text-align: center;
  font-size: 16px;
  color: #333333;
}
.el-menu {
  border-bottom: none;
  width: 140px;
}
.TechnicalBar >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
}
.TechnicalBar >>> .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  width: 140px;
}
.TechnicalBar >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}
.paging_flex_row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/*.HonoraryCertificate {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  flex-direction: column;*/
/*  width: 1200px;*/
/*  padding-bottom: 160px;*/
/*}*/
/*.Dynamic_title_name {*/
/*  font-weight: 400;*/
/*  text-align: center;*/
/*  font-size: 26px;*/
/*  color: #333333;*/
/*}*/
/*.Dynamic_title_text {*/
/*  text-align: center;*/
/*  font-size: 14px;*/
/*  color: #333333;*/
/*}*/
/*.HonoraryCertificate_content {*/
/*  width: 1200px;*/
/*}*/
/*.HonoraryCertificate_content_title{*/
/*  padding-bottom: 80px;*/
/*}*/

/* .HonoraryCertificate_content_img {
  display: flex;
  justify-content: start;
  align-items: center;
  !*flex-direction: column;*!
  flex-wrap: wrap;
  !*width: 85%;*!
  !*padding-bottom: 20px;*!
  !*margin-left: 100px;*!
  width: 1200px;
  width: 100%;
} */
/*.HonoraryCertificate_content_img1 {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*  width: 280px;*/
/*  padding-left: 20px;*/
/*  !*margin-bottom: 76px;*!*/
/*}*/
/*.HonoraryCertificate_content_img_item {*/
/*  margin: 35px 0;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  border: 1px solid #E5E5E5;*/
/*  width: 280px;*/
/*  height: 207px;*/
/*}*/
/*.HonoraryCertificate_content_img_item img,.HonoraryCertificate_content1_img img{*/
/*  width: 235px;*/
/*  height: 154px;*/
/*}*/
/*.HonoraryCertificate_content_img1_name span {*/
/*  font-size: 16px;*/
/*  color: #333333;*/
/*}*/

/*.HonoraryCertificate_content1 {*/
/*  padding-top: 100px;*/
/*  width: 1200px;*/
/*}*/
/*.HonoraryCertificate_content1_title{*/
/*  padding-bottom: 80px;*/
/*}*/

/*.HonoraryCertificate_content1_img {*/
/*  display: flex;*/
/*  justify-content: start;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  flex-wrap: wrap;*/
/*  !*width: 85%;*!*/
/*  !*padding-bottom: 20px;*!*/
/*  !*margin-left: 100px;*!*/
/*  width: 1200px;*/
/*  width: 100%;*/
/*}*/
/*.HonoraryCertificate_content1_img1 {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*  width: 280px;*/
/*  padding-left: 20px;*/
/*  !*margin-bottom: 76px;*!*/
/*}*/
/*.HonoraryCertificate_content1_img_item {*/
/*  margin: 35px 0;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  border: 1px solid #E5E5E5;*/
/*  width: 280px;*/
/*  height: 350px;*/
/*}*/
/*.HonoraryCertificate_content1_img_item img*/
/*{*/
/*  width: 250px;*/
/*  height: 340px;*/
/*}*/
/*.HonoraryCertificate_content1_img1_name span {*/
/*  font-size: 16px;*/
/*  color: #333333;*/
/*}*/

/*.el-divider__text.is-center {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/HonoraryCertificate.vue